import {
  Environment as DeviceEnvironment,
  generateDeviceId,
} from '@1debit/device-intelligence';

import { IS_PROD_ENV } from 'consts/appConsts';

/**
 * Builds the Tuner SDK configuration for enrollment-client
 *
 * Note: We don't provide actor attributes (user_id, email, etc.) because
 * enrollment users are not logged in, and these feature flags apply to all users.
 */
export function buildTunerConfig(deploymentEnv) {
  const isProd = IS_PROD_ENV;
  const deviceId = generateDeviceId({
    env: isProd
      ? DeviceEnvironment.Production
      : DeviceEnvironment.NonProduction,
  });

  return {
    env: deploymentEnv,
    service: 'enrollment-client',
    defaultNamespaceName: 'enrollment-client',
    deviceId,
    bundleName: 'enrollment',
  };
}
